/** Path segments only (no origin); used with the axios client `baseURL`. */
export const API_PATHS = {
  /** Call before verify when the server expects an OTP session (avoids 401 on verify). */
  SEND_LOGIN_OTP:
    process.env.REACT_APP_SEND_LOGIN_OTP_PATH || "/mobile/initiate-login",
  RESEND_LOGIN_OTP:
    process.env.REACT_APP_RESEND_LOGIN_OTP_PATH || "/mobile/resend-otp",
  VERIFY_LOGIN_OTP:
    process.env.REACT_APP_VERIFY_LOGIN_OTP_PATH || "/mobile/verify-login-otp",
  GENERATE_AUTH_TOKEN: "/mobile/generate-authtoken",
  CATEGORIES: "/cat/categories",
  CREATE_USER: "/v2/user/create",
  /** @param {string} categoryId */
  questionsForCategory: (categoryId) =>
    `/v2/questions/${encodeURIComponent(categoryId)}`,
  SUBMIT_REQUIREMENT: "/api/new/requirements/",
  SUBMIT_REQUIREMENT_WITHOUT_TOKEN: "/api/new/requirements/without-token",

  /** @param {string} userId Claim link id (path segment). */
  claimAccDetails: (userId) =>
    `/api/claim/acc-details/${encodeURIComponent(userId)}`,
  CLAIM_INITIATE: "/api/claim/initiate",
  CLAIM_END: "/api/claim/end",
};
